import React, { useState, useEffect } from "react";
import "./ScrollToTopButton.css";

const ScrollToTopButton = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollProgress(scrolled);
      setIsVisible(scrollTop > 100); // فقط وقتی اسکرول شد ظاهر شود
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!isVisible) return null;

  const radius = 22;
  const stroke = 3;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (scrollProgress / 100) * circumference;

  return (
    <button className="scroll-to-top-btn" onClick={handleClick}>
      <svg className="progress-ring" width="50" height="50">
        <circle
          className="progress-ring-bg"
          stroke="#ddd"
          strokeWidth={stroke}
          fill="transparent"
          r={radius}
          cx="25"
          cy="25"
        />
        <circle
          className="progress-ring-circle"
          stroke="#ff7a00"
          strokeWidth={stroke}
          fill="transparent"
          r={radius}
          cx="25"
          cy="25"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <span className="scroll-arrow">⬆</span>
    </button>
  );
};

export default ScrollToTopButton;
